import React from 'react';

// 3D Boosta lightning bolt — main brand mark
export function BoostaBolt({ size = 32, className = '', animate = false }) {
  const id = React.useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={`${className} ${animate ? 'bolt-pulse' : ''}`} aria-hidden>
      <defs>
        <linearGradient id={`bl-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFF89A"/>
          <stop offset="45%" stopColor="#E5FF00"/>
          <stop offset="100%" stopColor="#B8CC00"/>
        </linearGradient>
        <linearGradient id={`bh-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.9"/>
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0"/>
        </linearGradient>
      </defs>
      {/* base shadow */}
      <path d="M40 4 L14 34 L28 34 L22 60 L50 26 L34 26 Z" fill="rgba(0,0,0,0.45)" transform="translate(1.2, 2.2)"/>
      {/* main body */}
      <path d="M40 4 L14 34 L28 34 L22 60 L50 26 L34 26 Z" fill={`url(#bl-${id})`}/>
      {/* highlight (top-left facet) */}
      <path d="M40 4 L14 34 L28 34 L26 30 L40 12 Z" fill={`url(#bh-${id})`} opacity="0.55"/>
      {/* inner rim */}
      <path d="M40 4 L14 34 L28 34 L22 60 L50 26 L34 26 Z" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="0.6"/>
    </svg>
  );
}

// Zap credit currency icon — cyan variant, distinct but visually related
export function ZapBolt({ size = 20, className = '' }) {
  const id = React.useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden>
      <defs>
        <linearGradient id={`zl-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#B5FBFF"/>
          <stop offset="50%" stopColor="#00F0FF"/>
          <stop offset="100%" stopColor="#0099A8"/>
        </linearGradient>
      </defs>
      <path d="M40 4 L14 34 L28 34 L22 60 L50 26 L34 26 Z" fill="rgba(0,0,0,0.5)" transform="translate(1, 2)"/>
      <path d="M40 4 L14 34 L28 34 L22 60 L50 26 L34 26 Z" fill={`url(#zl-${id})`}/>
      <path d="M40 4 L14 34 L28 34 L26 30 L40 12 Z" fill="#ffffff" opacity="0.5"/>
      {/* Zap ring */}
      <circle cx="52" cy="12" r="4" fill="#E5FF00"/>
      <circle cx="52" cy="12" r="4" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="0.6"/>
    </svg>
  );
}

// Loading spinner using bolt
export function BoltLoader({ size = 48, label = 'Loading' }) {
  return (
    <div className="inline-flex flex-col items-center gap-3">
      <div className="bolt-spin"><BoostaBolt size={size}/></div>
      <span className="text-[10px] tracking-[0.3em] uppercase text-boosta-cyan font-bold">{label}</span>
    </div>
  );
}
